import { createContainer } from 'react-sweet-state';

export const RoutingStateContainer = createContainer<{
	contextId: string;
}>();
